import http from "@/http-common"

class NotificationDataService {
  getNotifications(headers: {}): Promise<any> {
    return http.get(`/auth/notifications`, { headers: headers })
  }

  deleteNotification(id: string | number): Promise<any> {
    return http.delete(`/auth/notifications/${id}`)
  }

  markNotificationAsRead(id: string | number): Promise<any> {
    return http.post(`/auth/notifications/${id}/read`)
  }

  getPreferences(): Promise<any> {
    return http.get(`/auth/notifications/preferences`)
  }

  updatePreferences(preferences: []): Promise<any> {
    const payload = {
      preferences: preferences,
    }

    return http.post(`/auth/notifications/preferences/update`, payload)
  }
}

export default new NotificationDataService()
